/** @jsx jsx */
import { jsx } from "theme-ui";
import React from "react";
import {
  bookTicketWrapStyles,
  containerStyles,
  navigationWrap,
  wrapStyles,
  headerTopPaddingStyles,
} from "./styles";
import { Box } from "@shared-components/Box/Box";
import { LinkCollectionLink } from "../../carlsberg-headless/types/LinkCollection";
import { Link } from "@shared-components/Link/Link";
import { useSiteContext } from "../../context/site/useSiteContext";
import { useDictionaryContext } from "../../context/dictionary/useDictionaryContext";
import { DICTIONARY_MAP } from "../../carlsberg-headless/dictionary-map";
import { OpeningHour } from "../../carlsberg-headless/types/OpeningHour";
import { Nullable } from "../../shared/types/util";
import { ButtonLink } from "@shared-components/Button/Button";
import { TaxonomiesField } from "../../carlsberg-headless/types/fields/Taxonomies";
import { ImageField } from "src/carlsberg-headless/types/fields/Image";
import { Image } from "@shared-components/Image/Image";
import { TAXONOMIES_MAP } from "../../carlsberg-headless/taxonomies-map";

export interface HeaderProps {
  navigation?: React.ReactElement;
  bookTicketLink?: LinkCollectionLink;
  cultureOpen?: string;
  openingHours?: Nullable<OpeningHour[]>;
  currentFrontpageUrl?: string;
  taxonomies?: TaxonomiesField;
  companyLogoPrimary?: ImageField;
  hideBookTicket?: boolean;
}

const PureHeader: React.FC<HeaderProps> = ({
  navigation,
  bookTicketLink,
  currentFrontpageUrl,
  companyLogoPrimary,
  hideBookTicket = false,
}) => {
  return (
    <Box sx={wrapStyles}>
      <Box sx={headerTopPaddingStyles} />
      {!hideBookTicket && bookTicketLink?.link?.url && (
        <Box sx={bookTicketWrapStyles}>
          <ButtonLink
            to={bookTicketLink.link.url}
            {...(bookTicketLink.link.target && {
              target: bookTicketLink.link.target,
            })}
            variant="whiteOutline"
            outline
            sx={{
              backgroundColor: "rgba(0, 0, 0, 0.1)",
            }}
          >
            {bookTicketLink.link.name ?? bookTicketLink.link.name}
          </ButtonLink>
        </Box>
      )}

      <Box sx={containerStyles}>
        <Link
          to={
            currentFrontpageUrl?.startsWith("/")
              ? currentFrontpageUrl
              : `/${currentFrontpageUrl}`
          }
          sx={{
            ":hover, :focus": {
              boxShadow: "none",
              transition: "opacity 200ms",
              opacity: 0.8,
            },
          }}
        >
          {companyLogoPrimary?.fullUrl && (
            <Image
              src={companyLogoPrimary?.fullUrl}
              alt="logo"
              sx={{ width: ["140px", null, "150px"] }}
            />
          )}
        </Link>
      </Box>
      <Box sx={navigationWrap}>{navigation}</Box>
    </Box>
  );
};

const Header: React.FC<HeaderProps> = (props) => {
  const { get } = useDictionaryContext();
  const {
    currentCulture,
    bookTicketLink,
    currentFrontpageUrl,
    pageTaxonomies,
  } = useSiteContext();

  return (
    <PureHeader
      bookTicketLink={bookTicketLink?.links?.[0]}
      cultureOpen={get(DICTIONARY_MAP.opening_hours.open, currentCulture)}
      currentFrontpageUrl={currentFrontpageUrl}
      taxonomies={pageTaxonomies}
      hideBookTicket={pageTaxonomies.includes(
        TAXONOMIES_MAP.page.page_hide_book_ticket_desktop
      )}
      {...props}
    />
  );
};

export { Header, PureHeader };
